import { getShortenCountryName } from '@/lib/use-origin-country';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import Help from '@/components/v2/help/Help';
import i18n from '@/settings/i18n';

const t = i18n.init('help');

export default function ContactUs() {
  return (
    <>
      <WebsiteSchema
        title={t`Help - Reebelo ${{ country: getShortenCountryName() }}`}
        description={t`Our mission is to refresh the way we all consume tech. We believe in a future where everyone has access to affordable electronics. Delivered through a platform built on sustainable values and quality-assured devices. Whether it's refurbished or new, buying or selling, it's time to say hello to Reebelo - APAC's fastest`}
      />
      <Help />
    </>
  );
}
